/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Tells the Real Estate pickers they sit in a page's filter row. Only the v2
 * FilterBar provides it, so the legacy branch never sees it; under v2 the
 * pickers render the v2 filter controls there and stay form inputs elsewhere
 * (dialogs, wizards).
 */

import { createContext, useContext } from 'react';

export const ReFilterBarContext = createContext(false);

export const useInReFilterBar = () => useContext(ReFilterBarContext);
